import IsLoading from "@/components/layouts/IsLoading";
import SetLinks from "@/components/layouts/SetLinks";
import Show from "@/components/layouts/Show";
import SourceDataFindingsList from "@/components/lists/findings/SourceDataFindingsList";
import TrialContext from "@/contexts/data/TrialContext";
import { SourceDataFindingsInstitutionCreateLink, SourceDataFindingsParticipantCreateLink, SourceDataFindingsTrialCreateLink } from "@/contexts/layouts/LinkContext";
import useTrialSourceDataFindings from "@/hooks/data/useTrialSourceDataFindings";
import { Typography } from "@mui/material";
import { FC, useContext } from "react";

const TrialSourceDataFindings: FC = () => {
    const { data: trial } = useContext(TrialContext);
    const { data: sourceDataFindings, loading: sourceDataFindingsLoading, validating: sourceDataFindingsValidating } = useTrialSourceDataFindings(trial?.id, { revalidateOnFocus: false });


    const loading = sourceDataFindingsLoading;
    const validating = sourceDataFindingsValidating;

    return (
        <>
            <SetLinks 
                createTrialLink={SourceDataFindingsTrialCreateLink} 
                createInstitutionLink={SourceDataFindingsInstitutionCreateLink} 
                createParticipantLink={SourceDataFindingsParticipantCreateLink}  
            />
            <IsLoading name="trial-findings-page" loading={loading} validating={validating} />
            <Show show={!loading}>
                <Typography variant="h1" gutterBottom>
                    Findings
                </Typography>
                <SourceDataFindingsList trialId={trial?.id} sourceDataFindings={sourceDataFindings} canAdd />
            </Show>
        </>
    )
};

export default TrialSourceDataFindings;